import { render, staticRenderFns } from "./ModalShowPublishSuccess.vue?vue&type=template&id=3167a4a4&scoped=true"
import script from "./ModalShowPublishSuccess.vue?vue&type=script&lang=js"
export * from "./ModalShowPublishSuccess.vue?vue&type=script&lang=js"
import style0 from "./ModalShowPublishSuccess.vue?vue&type=style&index=0&id=3167a4a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3167a4a4",
  null
  
)

export default component.exports